const eventsLoadMore = {
    /**
     * Binds the load-more control of every events block inside root, or of root itself when it
     * is one. Safe to call repeatedly: ACF replaces the preview DOM after every field change.
     */
    init: function( root, options = {} ) {
        const scope = root || document;
        const blocks = [];

        if ( scope.matches && scope.matches('.events') ) {
            blocks.push( scope );
        }

        if ( scope.querySelectorAll ) {
            blocks.push( ...scope.querySelectorAll('.events') );
        }

        blocks.forEach( (eventsBlock) => {
            eventsBlock.querySelectorAll('.events__load-more').forEach( (button) => {
                this.bindButton( button, eventsBlock, options );
            });
        });
    },

    bindButton: function( button, eventsBlock, options = {} ) {
        const listing = eventsBlock.querySelector('.events__listing');

        if ( ! listing || button.dataset.eventsReady === 'true' ) {
            return;
        }

        button.dataset.eventsReady = 'true';

        button.addEventListener('click', () => {
            this.loadMore( button, eventsBlock, listing, options );
        });
    },

    loadMore: function( button, eventsBlock, listing ) {
        // Localized by wp_localize_script on this script's own window, which is the page on the
        // frontend and the editor window in the block editor, never the canvas iframe.
        const settings = window.ajax;

        if ( ! settings ) {
            return;
        }

        const nextPage = parseInt(button.dataset.paged, 10) + 1;

        button.disabled = true;
        eventsBlock.classList.add('events--loading');

        const body = new URLSearchParams({
            action: settings.action_name,
            nonce: settings.nonce,
            paged: nextPage,
            posts_per_page: button.dataset.postsPerPage,
        });

        fetch(settings.ajax_url, {
            method: 'POST',
            body,
            credentials: 'same-origin',
        })
            .then((response) => response.json())
            .then((response) => {
                if (!response.success) {
                    button.disabled = false;
                    return;
                }

                listing.insertAdjacentHTML('beforeend', response.data.html);
                button.dataset.paged = nextPage;
                button.disabled = false;

                if (!response.data.has_more) {
                    button.remove();
                }
            })
            .catch(() => {
                button.disabled = false;
            })
            .finally(() => {
                eventsBlock.classList.remove('events--loading');
            });
    },
};

export default eventsLoadMore;

// The editor boots this module through src/js/_editor.js instead.
if ( ! window.acf ) {
    if ( document.readyState === 'loading' ) {
        document.addEventListener('DOMContentLoaded', () => eventsLoadMore.init( document, { isEditor: false } ));
    } else {
        eventsLoadMore.init( document, { isEditor: false } );
    }
}
